import { IGetReviewsWebResponse } from '../../repositories/newbuilding-reviews/entities/get_reviews_web/GetReviewsWebResponse';
import { IMappedReviewsResponse } from '../../types/reviews';

/*
 * Перемещение ответов по каждому отзыву в сквозную структуру
 * Замена объекта ответа на его идентификатор в объектах отзывов
 */
export function prepareReviews(response: IGetReviewsWebResponse): IMappedReviewsResponse {
  const { reviews, answers } = response.reviews.reduce(
    (acc, review) => {
      const { answers, answerIds } = (review.answers || []).reduce(
        (acc, el) => ({
          answers: {
            ...acc.answers,
            [el.id]: { ...el, reviewId: review.id },
          },
          answerIds: [...acc.answerIds, el.id],
        }),
        { answers: {}, answerIds: [] },
      );

      return {
        reviews: {
          allIds: [...acc.reviews.allIds, review.id],
          byId: {
            ...acc.reviews.byId,
            [review.id]: {
              ...review,
              answers: answerIds,
              areAnswersOpened: !!answerIds.length,
              answersPage: 0,
            },
          },
        },
        answers: {
          ...acc.answers,
          ...answers,
        },
      };
    },
    {
      reviews: { allIds: [], byId: {} },
      answers: {},
    },
  );

  return {
    ...response,
    reviews,
    answers,
  };
}
